export const PATHS = {
  main: {
    login: '/login',
    logout: '/logout',
    signUp: '/sign-up',
    requestPass: '/request-reset-password',
    resetPass: '/reset-password',
    resetPassSuccess: '/reset-password-success',
    verifyEmail: '/verify-email',
    npsScore: '/nps-score',
    dashboard: '/dashboard',
    errors: '/errors',
    oAuth2Callback: '/auth/social/callback',
    oAuth2CallbackMerge: '/auth/social/merge/callback',
    signUpOAuth2CallbackMerge: '/auth/social/signup',
    oAuth2ErrorCallback: '/auth/failure',
  },
  dashboard: {
    dashboard: '/dashboard',
    clients: '/clients',
    campaigns: '/campaigns',
    mission: '/mission',
    countries: '/countries',
    cities: '/cities',
    settings: '/settings',
    chat: '/chat',
    chatV2: '/chatV2',
    notFound: '/not-found',
    notAuthorised: '/not-authorised',
    profile: '/profile',
    rosters: '/rosters',
    clientCampaigns: '/client-campaigns',
    home: '/home',
    rejected: '/rejected',
    clientSettings: '/client-settings',
    userManagement: '/users',
    integration: '/integration',
    designManagement: '/design-management',
    integrations: '/integrations',
    audienceAndVariable: '/av',
    directMailWorkflows: '/direct-mail/workflows',
  },
  campaignsTypes: {
    active: '/active',
    d2d: '/d2d',
    h2h: '/h2h',
    dm: '/dm',
    dmEddm: '/dm/eddm',
    dmWorkflows: '/dm/workflows',
    dmAdm: '/dm/adm',
    inserts: '/inserts',
    eddm: '/eddm', // Some legacy routes end with just /eddm.
  },
  clientSettings: {
    coupons: '/coupons',
    stores: '/stores',
    store: '/store',
    createCoupon: '/create-coupon',
    csvUpload: '/csv-upload',
    couponsType: '/type',
    userManagement: '/users',
  },
  store: {
    storeView: '/:integrationId',
  },
  integrations: {
    api: '/api',
    swellStores: '/swell-stores',
    addSwellStore: '/add-swell-store',
  },
  userManagement: {
    userManagementDetailsCreate: '/create',
    userManagementDetailsView: '/:userId',
    userManagementDetailsEdit: '/:userId/edit',
  },
  profile: {
    edit: '/profile/edit',
  },
  countries: {
    settings: '/settings',
    pipeline: '/pipeline',
    globalPlaning: '/global-planing',
    channels: '/channels',
    weather: '/weather',
    projectManagement: '/project-management',
    baPayslip: '/ba-payslip',
    invoices: '/invoices',
  },
  cities: {
    edit: '/edit',
    add: '/add',
    ambassadors: '/ambassadors',
    ambassadorsList: '/ambassadors/list',
    ambassadorsPipeline: '/ambassadors/pipeline',
    ambassadorsEmails: '/ambassadors/emails',
    ambassadorsEmailsSequence: '/ambassadors/emails/:sequenceId',
    ambassadorsEmailsStats: '/ambassadors/emails/:sequenceId/stats',
    ambassadorsEmailsEdit: '/ambassadors/emails/:sequenceId/edit',
    ambassadorsEmailsCreate: '/ambassadors/emails/create',
    ambassador: '/ambassadors/:ambassadorId',
    ambassadorEdit: '/ambassadors/:ambassadorId/edit',
    ambassadorProfile: '/dashboard/cities/:cityId/ambassadors/:ambassadorId',
    ambassadorUploadDocuments: '/ambassadors/:ambassadorId/upload-documents',
    inventory: '/dashboard/cities/:cityId/inventory',
    movements: '/dashboard/cities/:cityId/inventory/:inventoryId/movements',
    locations: '/locations',
    locationsH2H: '/handtohand',
    locationsLB: '/letterbox',
    locationsDM: '/directmail',
    view: '/',
    masterSchedule: '/global-planning',
    stats: '/stats',
    missionView: '/master-schedule/missions/:missionId',
    missionEdit: '/master-schedule/missions/:missionId/edit',
    pickup: '/pickup',
    pickupAll: '/pickup/all',
    pickupBrief: '/pickup/brief',
    manageOnboardingTimes: '/manage-onboarding-times',
    managePickupTimes: '/manage-pickup-times',
    letterboxBuilder: '/letterbox-builder',
    spies: '/spies/:spyId',
    spiesEdit: '/spies/:spyId/edit',
    spyUploadDocuments: '/spies/:spyId/upload-documents',
    liveMap: '/live-map',
    spy: '/spy',
    distributionZones: '/distribution-zones',
    availabilities: '/ambassadors/availabilities',
  },
  clients: {
    add: '/add',
    clientView: '/:id',
    edit: '/:clientId/edit',
  },
  campaigns: {
    create: '/create',
    campaign: '/:campaignId',
  },
  campaign: {
    edit: '/edit',
    dashboard: '/dashboard',
    artwork: '/artwork',
    artworkAndOffers: '/artwork-and-offers',
    metricsBreakdown: '/metrics-breakdown',
    cityPlans: '/city-plans',
    cityPlanView: '/city-plans/:cityPlanId',
    rosterCreate: '/city-plans/:cityPlanId/rosters/create',
    rosterEdit: '/city-plans/:cityPlanId/rosters/:rosterId/edit',
    missionView: '/master-schedule/missions/:missionId',
    rosterMissionView:
      '/city-plans/:cityPlanId/rosters/:rosterId/missions/:missionId',
    letterboxMissionsMissionView: '/city-plans/:cityPlanId/missions/:missionId',
    letterboxMissionsMissionEdit:
      '/city-plans/:cityPlanId/missions/:missionId/edit',
    missionEdit: '/master-schedule/missions/:missionId/edit',
    rosterMissionEdit:
      '/city-plans/:cityPlanId/rosters/:rosterId/missions/:missionId/edit',
    cityPlanCreate: '/city-plans/create',
    masterSchedule: '/master-schedule',
    bonusResults: '/bonus-results',
    managePaidAmounts: '/manage-paid-amounts',
    clientQuestions: '/client-questions',
    codes: '/codes',
    codesFAQ: '/codes/what-are-codes',
    liveMap: '/live-map',
    internalFiles: '/internal-files',
    mailingList: '/mailing-list',
    conversions: '/conversions',
    logs: '/logs',
    codeManagement: '/code-management',
    detailedTracking: '/detailed-tracking',
  },
  // The same as the campaign route but without the unnecessary url params
  mission: {
    rosterMissionView: '/:missionId',
    missionEdit: '/:missionId/edit',
    rosterMissionEdit: '/:missionId/edit',
  },
  settings: {
    documentation: '/document-types',
    documentEdit: '/document-types/:id/edit',
    documentCreate: '/document-types/create',
    invoiceExport: '/invoice-export',
    legalDocumentation: '/legal-documents',
    legalDocumentationEdit: '/legal-documents/edit/:id',
    legalDocumentationCreate: '/legal-documents/create',
    tagsManagement: '/tags-management',
    tagsManagementEdit: '/tags-management/edit/:id',
    tagsManagementCreate: '/tags-management/create',
    npsScore: '/nps-score',
    urlShortener: '/url-shortener',
    xeroConnection: '/xero-connection',
    addPayment: '/add-payment',
  },
  chat: {},
  cityPlan: {
    rosterView: '/rosters/:rosterId',
    letterboxMissions: '/missions',
    cityPlanEdit: '/edit',
    aiRoster: '/ai-roster',
  },
  clientCampaignsDashboard: {
    monthly: '/monthly',
    campaign: '/campaign',
  },
  external: {
    tools: 'https://tools.oppizi.com',
  },
  designManagement: {
    upload: '/upload',
    design: '/design/:designId',
  },
}
